<div aria-modal="true" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" id="tab-modal">
    <mat-dialog-content role="document" class="tab-dialog-modal-content card-content">
        <div class="dialogTitle">
            <h4 class="card-title"> 
                {{data?.title}}</h4>
            <button
                *ngIf="!data?.hideCloseIcon"
                type="button"
                class="close-icon"
                aria-label="Close modal"
                (click)="close(null)">
                &times;
            </button>
        </div>
        <div class="description">
            <p class="card-Description"> {{data.description}} </p>
        </div>
        <div class="action">
            <button mat-flat-button *ngIf="!data.isLinkAvailable" (click)="close('conactSupport')"
                class="topaz-button-small button" id="smallStandardPrimaryBtn" aria-label="primary">Contact support</button>
            <button mat-flat-button *ngIf="data.isLinkAvailable" (click)="close('paymentLink')"
                class="topaz-button-small button" id="smallStandardPrimaryBtn" aria-label="primary">Proceed to payment</button>
        </div>
    </mat-dialog-content>
</div>